import {
  Modal,
  Paragraph,
  breakpoints,
  useMediaQuery
} from "@tvg/design-system";
import DOMPurify from "dompurify";
import { useColorTokens } from "@tvg/design-system/web/hooks";
import { buildQaLabel } from "@tvg/test-utils/utils";
import React from "react";
import { Props } from "./types";
import VideoPlayer from "../VideoPlayer";
import { Body, Description } from "./styled-components";
import { CONTAINER, MODAL, TEXT } from "../../constants";

const VideoPlayerModal = ({ item, onClose, qaLabel = "" }: Props) => {
  const isMobile = useMediaQuery(breakpoints.tablet.max.sm);
  const colors = useColorTokens();

  return (
    <Modal
      isOpen={!!item}
      onClose={onClose}
      onOverlayClick={onClose}
      title={item?.description.title ?? ""}
      type={isMobile ? "fullscreen" : "lightbox"}
      padding={0}
      qaLabel={buildQaLabel([qaLabel, MODAL, CONTAINER])}
    >
      <>
        {item && (
          <div>
            <VideoPlayer item={item} qaLabel={buildQaLabel([qaLabel, MODAL])} />
            <Body>
              <Description
                data-qa-label={buildQaLabel([qaLabel, MODAL, TEXT])}
                dangerouslySetInnerHTML={{
                  __html:
                    typeof window !== "undefined"
                      ? DOMPurify.sanitize(item.description.description)
                      : ""
                }}
              />
              <Paragraph
                qaLabel={buildQaLabel([qaLabel, MODAL, TEXT])}
                fontFamily="condensedRegular"
                textTransform="uppercase"
                color={colors.content.subtle}
                fontSize={12}
                textAlign="right"
              >
                {item.description.uploadedAt}
              </Paragraph>
            </Body>
          </div>
        )}
      </>
    </Modal>
  );
};

export default VideoPlayerModal;
